<template>
<div class="wrap">
    <schoolAndDate :schoolName="schoolName" :dateTime="dateTime" />

    <div class="page_index">
        <div class="header-title">
            <div class="title-item">品名</div>
            <div class="title-item">
                <span class="sub-title">(换算获得)</span>
                <span>采购价</span>
            </div>
            <div class="title-item">指导价</div>
            <div class="title-item">比升降</div>
            <div class="title-item">供应商</div>
        </div>

        <div class="page-body" ref="viewport" :style="viewportStyle">
            <transition name="page-turn-fade" mode="out-in">
                <div class="page-list-wrap" :key="currentPageKey">
                    <div class="page-section" v-for="section in currentPage.sections" :key="section.sectionKey">
                        <div class="page-row" v-for="row in section.rows" :key="row.rowKey">
                            <div class="flex flex_sb page_list">
                                <div class="page_name">{{ row.nameText }}</div>
                                <div class="page_price">
                                    <div class="page_num">{{ row.purchasePriceText }}</div>
                                    <div class="page_unit">元/{{ row.unitText }}</div>
                                </div>
                                <div class="page_price zhidao">
                                    <div class="page_num">{{ row.guidePriceText }}</div>
                                    <div class="page_unit" v-if="row.guidePriceText">元/{{ row.unitText }}</div>
                                </div>
                                <div class="page_price page_price_arrow">
                                    <img class="page_img" :src="renderArrow(row.compareValue)" alt="">
                                </div>
                                <div class="page_title page_supplier">
                                    <div v-for="(name, iname) in row.supplierLines" :key="iname">{{ name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <div class="measure-layer" aria-hidden="true">
                <div class="page-list-wrap measure-wrap" ref="measureContent">
                    <div class="page-section" v-for="(section, sectionIndex) in normalizedSections" :key="section.sectionKey + '-measure'">
                        <div class="page-row" v-for="(row, rowIndex) in section.rows" :key="row.rowKey" :ref="'measureRow-' + sectionIndex + '-' + rowIndex">
                            <div class="flex flex_sb page_list">
                                <div class="page_name">{{ row.nameText }}</div>
                                <div class="page_price">
                                    <div class="page_num">{{ row.purchasePriceText }}</div>
                                    <div class="page_unit">元/{{ row.unitText }}</div>
                                </div>
                                <div class="page_price zhidao">
                                    <div class="page_num">{{ row.guidePriceText }}</div>
                                    <div class="page_unit" v-if="row.guidePriceText">元/{{ row.unitText }}</div>
                                </div>
                                <div class="page_price page_price_arrow">
                                    <img class="page_img" :src="renderArrow(row.compareValue)" alt="">
                                </div>
                                <div class="page_title page_supplier">
                                    <div v-for="(name, iname) in row.supplierLines" :key="iname">{{ name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PageTurnControl class="page-turn-control-position" :current="currentPageIndex + 1" :total="pages.length" theme="article" @prev="goPrevPage" @next="goNextPage" />
        </div>
    </div>
</div>
</template>

<script>
    import {
        fontVh
    } from "@/assets/js/common";
    import PageTurnControl from "./PageTurnControl.vue";
    import schoolAndDate from "./schoolAndDate.vue";
    import { buildArticleListSections } from "../assets/js/articleListSections";
    import { paginateMeasuredSections } from "../assets/js/contentPaging";
    import { canAutoTurnPage, getNextPageIndex, getPrevPageIndex } from "../assets/js/pageTurn";

    export default {
        name: 'articleList',
        props: { 
            schoolName: {
                type: String,
                default: '',
            },
            dateTime: {
                type: String,
                default: '',
            },
            rankList: {
                type: Array,
                default: () => []
            },
            unit: {
                type: String,
                default: ''
            },
            uniIdx: {
                type: [Number, String],
                default: 1
            },
            // 用于改变数组列表单独一列文字靠左对齐
            active: {
                type: Number,
                default: -1
            },
            scrollHeight: {
                type: String,
                default: ''
            },
            speed: {
                type: Number,
                default: 0.3
            }
        },
        data() {
            return {
                iconArrUp: require("@/assets/images/icon_arrow_up.png"),
                iconArrDown: require("@/assets/images/icon_arrow_down.png"),
                iconArrNot: require("@/assets/images/icon_arrow_not.png"),
                pages: [],
                currentPageIndex: 0,
                pageTimer: null,
            }
        },
        components: { PageTurnControl, schoolAndDate },
        created() {},
        computed: {
            normalizedSections() {
                return buildArticleListSections(this.rankList)
            },
            currentPage() {
                return this.pages[this.currentPageIndex] || { sections: [] }
            },
            currentPageKey() {
                return `page-${this.currentPageIndex}`
            },
            viewportStyle() {
                return `height:${fontVh(this.scrollHeight)};`
            },
            autoplayDuration() {
                const query = this.$route && this.$route.query ? this.$route.query : {}
                const autoplay = query && query.autoplay ? parseInt(query.autoplay, 10) : 0

                if (isNaN(autoplay) || autoplay <= 0) {
                    return 0
                }

                return autoplay
            }
        },
        watch: {
            rankList: {
                deep: true,
                handler() {
                    this.rebuildPages()
                }
            },
            scrollHeight() {
                this.rebuildPages()
            },
            '$route.query.autoplay'() {
                this.startPageTimer()
            }
        },
        mounted() {
            this.rebuildPages()
            window.addEventListener('resize', this.rebuildPages)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.rebuildPages)
            this.stopPageTimer()
        },
        methods: {
            renderArrow(value) {
                if (value === 'gt') {
                    return this.iconArrUp
                }
                if (value === 'lt') {
                    return this.iconArrDown
                }
                return this.iconArrNot
            },
            stopPageTimer() {
                if (this.pageTimer) {
                    clearInterval(this.pageTimer)
                    this.pageTimer = null
                }
            },
            startPageTimer() {
                this.stopPageTimer()

                if (!canAutoTurnPage(this.pages.length, this.autoplayDuration)) {
                    return
                }

                this.pageTimer = setInterval(() => {
                    this.currentPageIndex = getNextPageIndex(this.currentPageIndex, this.pages.length)
                }, this.autoplayDuration)
            },
            restartPageTimer() {
                this.stopPageTimer()
                this.startPageTimer()
            },
            goPrevPage() {
                this.currentPageIndex = getPrevPageIndex(this.currentPageIndex, this.pages.length)
                this.restartPageTimer()
            },
            goNextPage() {
                this.currentPageIndex = getNextPageIndex(this.currentPageIndex, this.pages.length)
                this.restartPageTimer()
            },
            getRefElement(refName) {
                const refValue = this.$refs[refName]
                return Array.isArray(refValue) ? refValue[0] : refValue
            },
            getMeasureWrapInset() {
                const measureContent = this.$refs.measureContent

                if (!measureContent) {
                    return 0
                }

                const styles = window.getComputedStyle(measureContent)
                return (parseFloat(styles.paddingTop) || 0) + (parseFloat(styles.paddingBottom) || 0)
            },
            getMeasuredSection(section, sectionIndex) {
                return {
                    sectionKey: section.sectionKey,
                    sectionHeader: section.sectionHeader,
                    headerHeight: 0,
                    rows: section.rows.map((row, rowIndex) => {
                        const rowEl = this.getRefElement(`measureRow-${sectionIndex}-${rowIndex}`)
                        return {
                            rowKey: row.rowKey,
                            measuredHeight: rowEl ? rowEl.offsetHeight : 0,
                            payload: row,
                        }
                    })
                }
            },
            rebuildPages() {
                this.$nextTick(() => {
                    const viewport = this.$refs.viewport
                    const measuredSections = this.normalizedSections.map((section, index) => {
                        return this.getMeasuredSection(section, index)
                    })

                    this.pages = paginateMeasuredSections({
                        maxPageHeight: viewport ? viewport.clientHeight : 0,
                        pageInset: this.getMeasureWrapInset(),
                        sections: measuredSections,
                    }).map((page) => {
                        return {
                            pageIndex: page.pageIndex,
                            sections: page.sections.map((section) => {
                                return {
                                    sectionKey: section.sectionKey,
                                    sectionHeader: section.sectionHeader,
                                    continued: section.continued,
                                    rows: section.rows.map((row) => row.payload),
                                }
                            }),
                        }
                    })

                    this.currentPageIndex = 0
                    this.startPageTimer()
                })
            }
        }
    }
</script>

<style lang='scss' scoped>
    $textColor: #2E670B;
    .wrap {
        position: relative;
    }

    .page_index {
        word-break: break-all;
        overflow: hidden;
        // padding: 0 vh(20);
        display: flex;
        justify-content: center;
        position: relative;
        background: radial-gradient( 0% 0% at 0% 0%, #BAECCA 0%, #ECEDA2 0%);
        border-radius: 6px 6px 6px 6px;

        

        .header-title {
            position: absolute;
            z-index: 6;
            width: 100%;
            display: flex;
            font-size: vh(20);
            font-weight: bold;
            color: $textColor;
            padding: vh(30) vh(25) vh(10);
            background: radial-gradient( 0% 0% at 0% 0%, #BAECCA 0%, #ECEDA2 0%);
            .title-item:nth-of-type(1) {
                width: 55%;
                text-align: left;
            }
            .title-item:nth-of-type(2) {
                width: 44%;
                text-align: left;
                position: relative;
                .sub-title {
                    display: block;
                    font-size: vh(10);
                    position: absolute;
                    left: vh(7);
                    top: 0;
                    transform: translateY(-100%);
                }
            }
            .title-item:nth-of-type(3) {
                width: 45%;
                text-align: left;
            }
            .title-item:nth-of-type(4) {
                width: 11%;
            }
            .title-item:nth-of-type(5) {
                width: 66%;
            }
        }

        .page-body {
            position: relative;
            overflow: hidden;
            width: 100% !important;
        }

        .page-list-wrap {
            padding: vh(60) 0 vh(58);
        }

        .page-row {
            &:last-child {
                .page_list {
                    border-bottom: none;
                }
            }
        }

        .page_list {
            padding: vh(10) vh(25);
            text-align: center;
            border-bottom: 1px solid #96C59D;
            align-items: flex-start;

            div {
                text-align: left;
                justify-content: space-between;
            }

            .page_name {
                flex: 0 0 22%;
                width: 22%;
                min-width: 0;
                @include font(24-3, $textColor);
                font-weight: bold;
                white-space: normal;
                word-break: break-all;
                overflow-wrap: anywhere;
                line-height: 1.35;
            }

            .page_price {
                @include font(20-3, #106BC0, center);
                flex: 0 0 18%;
                width: 18%;
                min-width: 0;

                .page_num {
                    @include font(24, #106BC0, center);
                    font-weight: bold;
                }

                .page_unit {
                    text-align: center;
                    color: $textColor;
                }

                &.hide {
                    visibility: hidden;
                }
            }

            .page_price_arrow {
                flex: 0 0 8%;
                width: 8%;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .page_img {
                width: vh(14);
                display: block;
            }

            .page_title {
                width: 24%;
                display: flex;
                @include font(22-3, $textColor);
                font-weight: bold;
            }

            .page_supplier {
                flex: 0 0 24%;
                min-width: 0;
                flex-direction: column;
                white-space: normal;
                word-break: break-all;
                overflow-wrap: anywhere;
                line-height: 1.35;
            }
        }

        .measure-layer {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            visibility: hidden;
            pointer-events: none;
            z-index: -1;
        }

        .measure-wrap {
            padding: vh(60) 0 vh(58);
        }

        .page-turn-control-position {
            position: absolute;
            left: 50%;
            bottom: vh(8);
            z-index: 8;
            transform: translateX(-50%);
        }

        .page-turn-fade-enter-active,
        .page-turn-fade-leave-active {
            transition: opacity 0.45s ease, transform 0.45s ease;
        }

        .page-turn-fade-enter,
        .page-turn-fade-leave-to {
            opacity: 0;
            transform: translateX(vh(24));
        }
    }
</style>
